(function () {
  let openingCart = false;
  let pageReady = false;

  /*
   * Don't react to anything during initial page/app loading.
   */
  window.addEventListener('load', function () {
    setTimeout(function () {
      pageReady = true;
    }, 1500);
  });


  function openAmpCart() {
    if (!pageReady || openingCart) return;

    openingCart = true;

    /*
     * Give Recomma enough time to finish changing
     * the Shopify cart before AMP refreshes.
     */
    setTimeout(function () {
      try {

        /*
         * Refresh AMP Slide Cart
         */
        if (typeof window.SLIDECART_UPDATE === 'function') {
          window.SLIDECART_UPDATE();
        }

        /*
         * Open AMP Slide Cart
         */
        if (typeof window.SLIDECART_OPEN === 'function') {
          window.SLIDECART_OPEN();
        } else if (
          window.AMP_API &&
          typeof window.AMP_API.OPEN_CART === 'function'
        ) {
          window.AMP_API.OPEN_CART();
        }


        /*
         * Refresh again once cart data has settled.
         */
        setTimeout(function () {
          if (typeof window.SLIDECART_UPDATE === 'function') {
            window.SLIDECART_UPDATE();
          }
        }, 500);


        setTimeout(function () {
          if (typeof window.SLIDECART_UPDATE === 'function') {
            window.SLIDECART_UPDATE();
          }

          openingCart = false;
        }, 1000);

      } catch (error) {
        console.warn('Recomma → AMP Slide Cart:', error);
        openingCart = false;
      }

    }, 400);
  }


  /*
   * ---------------------------------------------------------
   * RECOMMA CART EVENTS ONLY
   * ---------------------------------------------------------
   *
   * We are NOT watching every Shopify cart fetch anymore.
   *
   * Therefore:
   *
   * Opening quiz           → NO DRAWER
   * Loading quiz results   → NO DRAWER
   * Visiting quiz page     → NO DRAWER
   *
   * Recomma changes cart   → OPEN DRAWER
   */
  window.addEventListener('message', function (event) {
    if (!pageReady || !event.data) return;

    const type = event.data.type;

    if (
      type === 'cartAdd' ||
      type === 'cartUpdate' ||
      type === 'cartRemove' ||
      type === 'cartChange'
    ) {
      openAmpCart();
    }
  });

})();